import { render, staticRenderFns } from "./FooterCopyright.vue?vue&type=template&id=079ac59e&scoped=true"
import script from "./FooterCopyright.vue?vue&type=script&lang=ts"
export * from "./FooterCopyright.vue?vue&type=script&lang=ts"
import style0 from "./FooterCopyright.vue?vue&type=style&index=0&id=079ac59e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079ac59e",
  null
  
)

export default component.exports